class ContractualAttendanceStrategy {
     constructor () {
          this.gracePeriodMinutes = 10;
          this.employeeType = 'Contractual_Employee';
          this.nationalHolidays = ['01-26', '08-15', '10-02']; // 26 Jan, 15 Aug, 2 Oct
     }

     calculateAttendanceStatus(day, roster, holidays, employeeData) {
          const dateObj = new Date(day.date);
          const punchIn = day.punch_in ? new Date(day.punch_in) : null;
          const punchOut = day.punch_out ? new Date(day.punch_out) : null;

          // Extract roster details - FIXED: use correct field names from API
          const shiftStart = roster?.in_time;  // Changed from ShiftStart
          const shiftEnd = roster?.out_time;   // Changed from ShiftEnd

          // Convert total_hours (8.83) to minutes for full day
          const totalHoursDecimal = parseFloat(roster?.total_hours || "0");
          const fullDayMinutes = Math.round(totalHoursDecimal * 60);

          // Half day hours from roster
          const halfDayHoursDecimal = parseFloat(roster?.WorkingsHoursToBeConsiderdHalfDay || "0");
          const halfDayMinutes = Math.round(halfDayHoursDecimal * 60);

          const gracePeriod = this.gracePeriodMinutes; // Fixed 10 minutes grace

          // ============= PRIORITY 1: FUTURE DATE =============
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const currentDate = new Date(day.date);
          currentDate.setHours(0, 0, 0, 0);
          const isFutureDate = currentDate > today;

          if (isFutureDate) {
               return {
                    status: "-",
                    lateMark: "-",
                    workingHours: "-",
                    statusColor: "#94a3b8",
                    remarks: "Future Date"
               };
          }

          // ============= PRIORITY 2: WEEKLY OFF =============
          // Check custom_weekoff_date field from roster
          const isWeekOff = roster?.custom_weekoff_date !== null && roster?.custom_weekoff_date !== undefined;

          if (isWeekOff) {


               return {
                    status: "Week Off",
                    lateMark: "-",
                    workingHours: "-",
                    statusColor: "#3b82f6",
                    remarks: "Weekly Off"
               };
          }

          // ============= PRIORITY 3: NO ROSTER/SHIFT ASSIGNED - LOP =============
          // SOP: "If no shift is assigned to an employee for the day, that day will be treated as Loss of Pay (LOP)"
          if (!roster || !roster.shift_id) {
               return {
                    status: "LOP",
                    lateMark: "-",
                    workingHours: "-",
                    statusColor: "#ef4444",
                    remarks: "No shift assigned"
               };
          }

          // ============= PRIORITY 4: NATIONAL HOLIDAYS =============
          const holidayObj = holidays?.find(h => h.holiday_date === day.date);
          if (holidayObj && this.isNationalHoliday(holidayObj.holiday_date)) {
               if (this.isSandwichPolicy(day.date, employeeData)) {
                    return {
                         status: "LOP",
                         lateMark: "-",
                         workingHours: "-",
                         statusColor: "#ef4444",
                         remarks: "Sandwich Policy - Absent before and after holiday"
                    };
               }

               return {
                    status: holidayObj.holiday_name,
                    lateMark: "-",
                    workingHours: "-",
                    statusColor: "#f59e0b",
                    remarks: "National Holiday"
               };
          }

          // ============= PRIORITY 5: MISSED PUNCHES - LOP =============
          // SOP: "If an employee forgets to swipe in or out, it will be marked as Loss of Pay (LOP)"
          if (!punchIn || !punchOut) {
               return {
                    status: "LOP",
                    lateMark: "-",
                    workingHours: "-",
                    statusColor: "#ef4444",
                    remarks: "Missed punch in/out"
               };
          }

          // ============= CALCULATE WORKING HOURS =============
          // Use worked_seconds from API response
          const workedMinutes = Math.round(day.worked_seconds / 60);
          const workingHours = this.calculateWorkingHours(punchIn, punchOut);

          // ============= PRIORITY 6: INSUFFICIENT HOURS - ABSENT/LOP =============
          // SOP: "If an employee works less than half of the required working hours, it will be considered as LOP"
          if (workedMinutes < halfDayMinutes) {
               return {
                    status: "LOP",
                    lateMark: "-",
                    workingHours,
                    statusColor: "#ef4444",
                    remarks: `Less than half day hours (${this.minutesToHours(halfDayMinutes)} required)`
               };
          }

          // ============= CALCULATE LATE LOGIN =============
          let isLateLogin = false;
          let lateMark = "-";

          if (shiftStart && punchIn) {
               const shiftStartDate = new Date(day.date + "T" + shiftStart);
               const graceEndTime = new Date(shiftStartDate.getTime() + (gracePeriod * 60000));

               if (punchIn > graceEndTime) {
                    isLateLogin = true;
                    lateMark = "Late";
               }
          }

          // ============= CALCULATE EARLY LOGOUT =============
          // SOP: "If an employee leaves before designated out-time even by a minute it will be considered as Half-day"
          let isEarlyLogout = false;

          if (shiftEnd && punchOut) {
               const shiftEndDate = new Date(day.date + "T" + shiftEnd);

               if (punchOut < shiftEndDate) {
                    isEarlyLogout = true;
               }
          }

          // ============= PRIORITY 7: LATE LOGIN + EARLY LOGOUT = LOP =============
          // SOP: "If an employee logged in late and logged out early before shift end time, will be considered as LOP"
          if (isLateLogin && isEarlyLogout) {
               return {
                    status: "LOP",
                    lateMark: "Late",
                    workingHours,
                    statusColor: "#ef4444",
                    remarks: "Late login after grace period and early logout"
               };
          }

          // ============= PRIORITY 8: EARLY LOGOUT = HALF DAY =============
          // SOP: "If employee leaves before designated OUT-Time even by a minute it will be considered as Half-day"
          if (isEarlyLogout) {
               return {
                    status: "Half Day",
                    lateMark,
                    workingHours,
                    statusColor: "#f59e0b",
                    remarks: "Left before shift end time"
               };
          }

          // ============= PRIORITY 9: LATE LOGIN AFTER GRACE = HALF DAY =============
          // SOP: "An employee who arrives after the designated grace period will be marked as half-day"
          if (isLateLogin) {
               return {
                    status: "Half Day",
                    lateMark: "Late",
                    workingHours,
                    statusColor: "#f59e0b",
                    remarks: "Late login after grace period"
               };
          }

          // ============= PRIORITY 10: WORKING HOURS VALIDATION =============
          // For shift PH 45 12:00 TO 21:00: total_hours = 8.83 (530 mins), half_day = 4.50 (270 mins)
          // Full day requires: 8 hrs 50 mins (530 mins) as per SOP table

          if (workedMinutes >= fullDayMinutes) {
               return {
                    status: "Present",
                    lateMark,
                    workingHours,
                    statusColor: "#10b981",
                    remarks: ""
               };
          }
          else if (workedMinutes >= halfDayMinutes) {
               return {
                    status: "Half Day",
                    lateMark,
                    workingHours,
                    statusColor: "#f59e0b",
                    remarks: "Insufficient working hours"
               };
          }
          else {
               return {
                    status: "LOP",
                    lateMark,
                    workingHours,
                    statusColor: "#ef4444",
                    remarks: "Less than half day hours"
               };
          }
     }

     calculateWorkingHours(punchIn, punchOut) {
          if (!punchIn || !punchOut) return '00:00';

          const punchInDate = new Date(punchIn);
          const punchOutDate = new Date(punchOut);
          const diffMs = punchOutDate - punchInDate;

          if (diffMs <= 0) return '00:00';

          const totalMinutes = Math.floor(diffMs / (1000 * 60));
          const hours = Math.floor(totalMinutes / 60);
          const minutes = totalMinutes % 60;

          return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
     }

     minutesToHours(minutes) {
          const hours = Math.floor(minutes / 60);
          const mins = minutes % 60;
          return `${hours}:${String(mins).padStart(2, '0')}`;
     }

     isNationalHoliday(date) {
          const dateStr = date.substring(5);
          return this.nationalHolidays.includes(dateStr);
     }

     getWeeklyWorkingDays(currentDate, employeeData) {
          const date = new Date(currentDate);
          const dayOfWeek = date.getDay();
          const monday = new Date(date);
          monday.setDate(date.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

          const sunday = new Date(monday);
          sunday.setDate(monday.getDate() + 6);

          const weekAttendance = employeeData?.days || [];
          let workingDays = 0;

          weekAttendance.forEach(day => {
               const dayDate = new Date(day.date);
               if (dayDate >= monday && dayDate <= sunday) {
                    // Count if there were punches (worked day)
                    if (day.punch_in && day.punch_out) {
                         workingDays++;
                    }
               }
          });

          return workingDays;
     }

     isSandwichPolicy(currentDate, employeeData) {
          const date = new Date(currentDate);
          const attendance = employeeData?.days || [];

          const prevDay = new Date(date);
          prevDay.setDate(date.getDate() - 1);
          const prevDayStr = prevDay.toISOString().split('T')[0];

          const nextDay = new Date(date);
          nextDay.setDate(date.getDate() + 1);
          const nextDayStr = nextDay.toISOString().split('T')[0];

          const prevDayAttendance = attendance.find(a => a.date === prevDayStr);
          const nextDayAttendance = attendance.find(a => a.date === nextDayStr);

          // Check if both days have no punches (absent/LOP)
          const isPrevDayAbsent = prevDayAttendance && (!prevDayAttendance.punch_in || !prevDayAttendance.punch_out);
          const isNextDayAbsent = nextDayAttendance && (!nextDayAttendance.punch_in || !nextDayAttendance.punch_out);

          return isPrevDayAbsent && isNextDayAbsent;
     }
}

export default ContractualAttendanceStrategy;